import Session from "supertokens-web-js/recipe/session";

export async function getEmailFromSession() {
  if (await Session.doesSessionExist()) {
    let accessTokenPayload = await Session.getAccessTokenPayloadSecurely();
    let email = accessTokenPayload.user_info.email;
    return email;
  }
}
